import { emptyRow } from './commissionSheetForm';
import {
  distributeOptionistPercentages,
  optionistReportPercent,
} from './commissionOptionistReport';

export function useRealEstateCommissionInstallmentRows({
  form,
  optionistReport,
  optionistReportTypes,
  scheduleSave,
}) {
  const updateRowFields = (group, index, attributes) => {
    const rows = [...(form.value[group] || [])];
    rows[index] = { ...rows[index], ...attributes };
    form.value = { ...form.value, [group]: rows };
    scheduleSave();
  };

  const updateRow = (group, index, field, value) => {
    updateRowFields(group, index, { [field]: value });
  };

  const redistributeOptionists = (rows, reportType) => {
    if (!reportType) return rows;

    const percent = optionistReportPercent(
      optionistReportTypes.value,
      reportType
    );
    return distributeOptionistPercentages(rows, percent).map(row => ({
      ...row,
      tipo_laudo_opcionista: reportType,
    }));
  };

  const emptyRowFor = group => ({
    ...emptyRow(),
    tipo_pessoa:
      group === 'empresas' || group === 'repasse_franquias' ? 'PJ' : 'PF',
  });

  const setRowCount = (group, count) => {
    const target = Math.max(0, Number(count) || 0);
    const rows = [...(form.value[group] || [])].slice(0, target);
    while (rows.length < target) rows.push(emptyRowFor(group));

    const nextRows =
      group === 'corretores_opcionistas'
        ? redistributeOptionists(rows, optionistReport.value)
        : rows;
    form.value = { ...form.value, [group]: nextRows };
    scheduleSave();
  };

  const addRow = group => {
    setRowCount(group, (form.value[group] || []).length + 1);
  };

  const removeRow = (group, index) => {
    const rows = (form.value[group] || []).filter(
      (_, rowIndex) => rowIndex !== index
    );
    const nextRows =
      group === 'corretores_opcionistas'
        ? redistributeOptionists(rows, optionistReport.value)
        : rows;
    form.value = { ...form.value, [group]: nextRows };
    scheduleSave();
  };

  const setOptionistReport = reportType => {
    const rows = form.value.corretores_opcionistas || [];
    form.value = {
      ...form.value,
      corretores_opcionistas: redistributeOptionists(rows, reportType),
    };
    scheduleSave();
  };

  const setRecipient = (group, index, user) => {
    updateRowFields(group, index, {
      usuario_id: user?.usuario_id || user?.id || '',
      empresa_id: user?.empresa_id || '',
      name: user?.name || '',
      nome_empresarial: user?.nome_empresarial || '',
      cpf: user?.cpf || '',
      cnpj: user?.cnpj || '',
      creci: user?.creci || '',
    });
  };

  return {
    addRow,
    removeRow,
    setOptionistReport,
    setRecipient,
    setRowCount,
    updateRow,
    updateRowFields,
  };
}
